import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'ui-form-card-panel-container',
  templateUrl: './ui-form-card-panel-container.component.html',
  styleUrls: ['./ui-form-card-panel-container.component.scss']
})
export class UiFormCardPanelContainerComponent {
  @Input() label: string = '';
  @Input() buttonLabel: string = '';
  @Input() isEditing: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() hideAddButton: boolean = false;
  @Input() showButton: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() loadingMessage: string = '';
  @Input() buttonText: string = '';
  @Output() buttonClick = new EventEmitter();
  @Output() addClick = new EventEmitter();

  constructor(private _viewportScroller: ViewportScroller) { }

  onAddClick() {
    this.addClick.emit();

    setTimeout(() => this._viewportScroller.scrollToAnchor('editForm'));
  }

  onbuttonClick() {
    this.buttonClick.emit();
  }
}
